import { FC } from 'react';
import classNames from 'classnames';
import Tag from '../../svgs/Tag';
import { getTagStyles } from '../../lib/colors';

type ProgramTagChipProps = {
  tag: { name: string; color: string };
  className?: string;
  iconClassName?: string;
};

const ProgramTagChip: FC<ProgramTagChipProps> = ({
  tag,
  className,
  iconClassName,
}) => {
  const styles = getTagStyles(tag.color);

  return (
    <span
      className={classNames(
        'inline-flex items-center gap-2 rounded-full px-3 py-1 text-small-caption',
        className,
      )}
      style={styles}
    >
      <Tag className={classNames('h-4 w-4 min-w-[1rem]', iconClassName)} />
      <span className="max-w-[200px] truncate">{tag.name}</span>
    </span>
  );
};

export default ProgramTagChip;
